module.exports = new __parcel__URL__("stamp03.f461d67d.png").toString();